import _ from 'underscore';
import queryString from 'query-string';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
  FetchPolicy,
} from '@bingads-webui-react/overreact';
import type { RequestFactoryContext } from '@bingads-webui-react/overreact';

import { schema } from '../../../environment/schema';
import { getDefaultOptions } from '../../../request-contract-helper';
import type {
  Customer,
  CustomerMutationData,
  CustomerVariables,
} from '../../../types';

function ccUrlFactory(params: RequestFactoryContext<CustomerVariables, CustomerMutationData>) {
  const { variables } = params;

  const {
    locator,
  } = variables;

  const { descriptor } = locator;
  const { uid, cid } = descriptor;

  const search = {
    uid,
    cid,
    id: cid,
  };

  const searchString = _.isEmpty(search) ? '' : `?${queryString.stringify(search)}`;

  return `cc/API/Customer${searchString}`;
}

function ccOptionsFactory() {
  return getDefaultOptions();
}


function ccPayloadFactory(params: RequestFactoryContext<CustomerVariables, CustomerMutationData>) {
  const { data } = params;
  return data.Customer ? data : { Customer: data };
}

export const mutationRequestContract = createRequestContract<CustomerVariables, CustomerMutationData>({
  schema,
  dataPath: 'user:customer',
  verb: requestVerbs.PATCH,
  fetchPolicy: FetchPolicy.NetworkOnly,
  uriFactoryFn: ccUrlFactory,

  headerFactoryFn: ccOptionsFactory,
  payloadFactoryFn: ccPayloadFactory,

  keySelector: variables => variables.locator.descriptor.cid,

  parentKeySelector: variables => variables.locator.descriptor.uid,
});

export const mutationResponseContract = createResponseContract<
  CustomerVariables,
  CustomerMutationData,
  Customer,
  Customer,
  Customer
>({
  requestContract: mutationRequestContract,
  responseType: responseTypes.ENTITY,

  keySelector: customer => customer.id,
  processorFn: response => response,
});
